import { useEffect } from "react";
import { useGetAppConfig } from "@/queries/config/config.api";

export const useDynamicFavicon = () => {
  const { data: appConfig } = useGetAppConfig();

  useEffect(() => {
    if (appConfig?.logo) {
      // Buscar todos los elementos link de favicon/icon existentes
      const existingFavicons = document.querySelectorAll('link[rel*="icon"]');

      // Remover los favicons existentes
      existingFavicons.forEach((favicon) => favicon.remove());

      // Crear un nuevo favicon con la URL dinâmica
      const faviconLink = document.createElement("link");
      faviconLink.rel = "icon";
      faviconLink.type = "image/png";
      faviconLink.href = appConfig.logo;

      // Agregar el nuevo favicon al head
      document.head.appendChild(faviconLink);

      // También agregar como shortcut icon para mejor compatibilidad
      const shortcutLink = document.createElement("link");
      shortcutLink.rel = "shortcut icon";
      shortcutLink.type = "image/png";
      shortcutLink.href = appConfig.logo;
      document.head.appendChild(shortcutLink);
    }
  }, [appConfig?.logo]);
};
